export const inDevelopment = () => import.meta.env.DEV;

export const inProduction = () =>
  !inDevelopment() && window.location.hostname === "app.clientzen.io";

export const inStaging = () =>
  !inDevelopment() && window.location.hostname === "app-staging.clientzen.io";

export const isFeatureEnabled = (featureFlag) => featureFlag === "true";
